import { Observable, map } from 'rxjs';
import { environment } from '@utility/app.util';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IAdminUser, IAdminUserServer } from '@lib/admin-users.interface';
import { IOptInSettings, IOptInSettingsResquest, IOptInSettingsServer } from '@lib/opt-in-settings.interface';

@Injectable()
export class OptInService {

  constructor(private http: HttpClient) { }

  public getOptInSettings(): Observable<IOptInSettings> {
    return this.http.get<{ data: IOptInSettingsServer }>(`${environment.apiUrl}/v2/client/opt-in-settings`)
      .pipe(
        map((response: { data: IOptInSettingsServer }) => this.transformOptInSettings(response.data)),
      )
    ;
  }

  public updateOptInSettings(data: IOptInSettingsResquest): Observable<IOptInSettings> {
    return this.http.put<{ data: IOptInSettingsServer }>(`${environment.apiUrl}/v2/client/opt-in-settings`, data)
      .pipe(
        map((response: { data: IOptInSettingsServer }) => this.transformOptInSettings(response.data)),
      )
    ;
  }

  private transformOptInSettings(data: IOptInSettingsServer): IOptInSettings {
    if (!data) return null;
    return {
      id: data?.id,
      clientId: data.client_id,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      notReact: !!data.not_react,
      notOpened: !!data.not_opened,
      autoResend: !!data.auto_resend,
      resendAfterDays: data.resend_after_days,
      sendWelcomeEmail: !!data.send_welcome_email,
      notificationAdmins: data?.notification_admin_ids ? this.transformAdminUsers(data.notification_admin_ids) : [],
    };
  }

  private transformAdminUsers(users: IAdminUserServer[]): IAdminUser[] {
    return users.map((user: IAdminUserServer): IAdminUser => ({ id: user.id, title: user.name }));
  }
}
